import { getParentByClass, scrollToID } from "../Helper/helper";

export let StoreSearch = {
  /**
   * Init store filters
   */
  initSearch: function () {
    const that = this;

    const allSearchfields = document.querySelectorAll(
      ".mb-floorplan-search-container"
    );

    for (let i = 0; i < allSearchfields.length; i++) {
      const domElements = {
        mbSearch: allSearchfields[i],
        mbSearchInner: allSearchfields[i].querySelector(
          ".mb-floorplan-search-container__inner"
        ),
        mbSearchInput: allSearchfields[i].querySelector("input"),
        mbSearchPreview: allSearchfields[i].querySelector(
          ".mb-floorplan-search-preview"
        ),
      };

      // Init event listener
      if (domElements.mbSearchInput) {
        domElements.mbSearchInput.addEventListener("input", function (event) {
          event.cancelBubble = true;
          event.preventDefault();
          that.searchStores(this.value, domElements);
        });

        // hide search results if click outside search elements
        document.addEventListener("click", function (e) {
          const parentContainerInner = getParentByClass(
            e.target,
            "mb-floorplan-search-container__inner"
          );

          // return if click inside searchfield
          if (
            !e.target.classList.contains("store-title") &&
            (e.target == domElements.mbSearchInner || parentContainerInner)
          ) {
            return;
          }

          // complete input value after clicking on searchresult
          if (
            e.target.classList.contains("store-title") &&
            parentContainerInner &&
            parentContainerInner == domElements.mbSearchInner
          ) {
            domElements.mbSearchInput.value = e.target.innerHTML;

            if (domElements.mbSearch.dataset.scroll == "true") {
              scrollToID(domElements.mbSearch.dataset.floorplan, -50);
            }
          }

          domElements.mbSearchPreview.innerHTML = "";
        });
      }
    }
  },

  /**
   * filter stores via ajax
   * @param {dom} target
   */
  searchStores: function (value, domElements) {
    if (window.xhrSearchStore) {
      // cancel currently running ajax search
      // fallback to error handler!
      window.xhrSearchStore.abort();
      domElements.mbSearchPreview.classList.remove("mb-loading");
    }

    if (value.length >= 1) {
      const that = this;
      domElements.mbSearchPreview.classList.add("mb-loading");

      window.xhrSearchStore = jQuery.ajax({
        url: mb_plugin_globalvars.ajaxurl,
        type: "POST",
        data: {
          action: "ajax_handle_search_stores",
          searchvalue: value,
        },
        success: function (response) {
          // do something on success
          // console.log(response.data);
          if (domElements.mbSearchPreview) {
            domElements.mbSearchPreview.classList.remove("mb-loading");
            domElements.mbSearchPreview.innerHTML = response.data;
          }
        },
        error: function () {
          //do something on error
          // console.log("No serach result");
        },
      });
    } else {
      domElements.mbSearchPreview.classList.remove("mb-loading");
      domElements.mbSearchPreview.innerHTML = "";
    }
  },
};
